import CryptoJS from 'crypto-js'
export const encryption = (data) => {
        /*AES前端加密*/
        var key = CryptoJS.enc.Utf8.parse('JZ4tfuFvgw0MkQ2J')
        var iv = CryptoJS.enc.Utf8.parse('JZ4tfuFvgw0MkQ2J')
        var str = CryptoJS.AES.encrypt(data, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString()
        return filter(str)
}
function filter (value){
    value=value.replace('#','%23')
    .replace('%','%25')
    .replace('&','%26')
    .replace('+','%2B')
    .replace('//','%2F')
    .replace('?','%3F')
    return value
}